<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="visible"
    :title="rowInfo.id==''?'添加':'编辑'"
    :loading="loading"
    @close="closeForm"
    width="60%">
    <span class="formContent">
      <el-form ref="rowInfo" :model="rowInfo" :rules="rules" label-width="150px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="所属城市" prop="cityCode">
              <el-select v-model="rowInfo.cityCode" clearable filterable placeholder="请选择派单城市">
                <el-option
                  v-for="item in cityOptions"
                  :key="item.codeItemId"
                  :label="item.codeName"
                  :value="item.codeItemId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="提前下单时间" prop="timeRegion">
              <el-select v-model="rowInfo.timeRegion" placeholder="请选择提前下单时间">
                <el-option label="1小时" value="1"></el-option>
                <el-option label="2小时" value="2"></el-option>
                <el-option label="3小时" value="3"></el-option>
                <el-option label="5小时" value="5"></el-option>
                <el-option label="8小时" value="8"></el-option>
                <el-option label="1天" value="24"></el-option>
                <el-option label="2天" value="48"></el-option>
                <el-option label="3天" value="72"></el-option>
                <el-option label="5天" value="100"></el-option>
                <el-option label="不限" value="-1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
           <el-form-item label="推送B类司机时间" prop="timeRegion">
              <el-select v-model="rowInfo.pushTimeRegionBl" placeholder="请选择推送B类司机时间">
                <el-option label="15分钟" value="15"></el-option>
                <el-option label="30分钟" value="30"></el-option>
                <el-option label="45分钟" value="45"></el-option>
                <el-option label="1小时" value="60"></el-option>
                <el-option label="1个半小时" value="90"></el-option>
                <el-option label="2小时" value="120"></el-option>
                <el-option label="不限" value="-1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
          <el-form-item label="推送C类司机时间" prop="timeRegion">
              <el-select v-model="rowInfo.pushTimeRegionCl" placeholder="请选择推送C类司机时间">
                <el-option label="15分钟" value="15"></el-option>
                <el-option label="30分钟" value="30"></el-option>
                <el-option label="45分钟" value="45"></el-option>
                <el-option label="1小时" value="60"></el-option>
                <el-option label="1个半小时" value="90"></el-option>
                <el-option label="2小时" value="120"></el-option>
                <el-option label="不限" value="-1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </span>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="submitForm('rowInfo')">保存</el-button>
        <el-button size="mini"  @click="closeForm">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { updBaseInfoSet,qryBaseInfoSet } from  "@/api/order/orderinfo"
import { citys } from '@/const/city.js'
export default {
  components: {
  },
  data() {
    return {
      visible: false,
      formName: '新增',
      loading: false,
      rowInfo:{
        id:'',
        cusId:'',
        timeRegion:'',
        pushTimeRegionBl:'',
        pushTimeRegionCl:'',
        cityCode:'',
        cityName: ''
      },
      rules: {
        cityCode: [{ required: true, message: '请选择所属城市', trigger: 'change' }],
        timeRegion: [{required: true, message: '请选择提前下单时间', trigger: 'change'}],
        pushTimeRegionBl: [{required: true, message: '请选择推送B类司机时间', trigger: 'change'}],
        pushTimeRegionCl: [{required: true, message: '请选择推送C类司机时间', trigger: 'change'}]
      },
      cityOptions:citys
    }
  },
  mounted() {
  },
  methods: {
    init(id) {
      this.visible = true
      if(id){
        this.loading = true;
        qryBaseInfoSet(id).then(res => {
          this.loading = false;
          this.rowInfo = res.data.data
        })
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
            let obj = {};
            obj = this.cityOptions.find(item => {
              return item.codeItemId === this.rowInfo.cityCode //筛选出匹配数据
            })
            this.rowInfo.cityName = obj.codeName;
          updBaseInfoSet(this.rowInfo).then((res) => {
            if(res.data.code==0){
              // 在store中改变修改的值
              this.$message.success("操作成功")
              // 子组件中触发父组件的初始化方法
              this.$emit('refresh', '')
              // 关闭弹框
              this.closeForm()
            }
          })
        } else {
          return false
        }
      })
    },
    closeForm() {
      this.visible = false
      // 重置表单
      this.$refs['rowInfo'].resetFields()
      this.rowInfo = {
        id:'',
        cusId:'',
        timeRegion:'',
        pushTimeRegionBl:'',
        pushTimeRegionCl:'',
        cityCode:'',
        cityName: ''
      }
    }
  }
}
</script>
<style scoped  rel="stylesheet/scss">
  .sideBarForm{
    overflow: auto;
    height: calc(100vh - 80px);
    margin-top: 40px;
  }
  .fullScreen .formHead,.fullScreen .formButton{
    right: 0;
  }
  .formHead{
    position: fixed;
    right:-420px;
    top:0;
    background-color: #27c3dc;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
  }
  .formBack{
    width: 40px;
    text-align: center;
    height: 100%;
    background-color: #ffbf00;
    font-size: 16px;
    color:#ffffff;
    line-height: 40px;
    cursor: pointer;
  }
  .listName{
    color:#ffffff;
    font-size: 16px;
    line-height: 40px;
    padding-left: 20px;
  }
  .formContent{
    padding: 20px;
  }
  .formButton{
    position: fixed;
    right:-420px;
    bottom:0;
    background-color: #ffffff;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .avatar-uploader .el-upload{
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    font-size: 28px;
    color: #8c939d;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
  .avatar {
    width: 50px;
    height: 50px;
    display: block;
  }
</style>
